import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {RQ_GET_WHATSAPP_CONSENT_API} from '@app/reactQuery/apis/constants';

export const RqWhatsappConsentReportAPI = (payload, options = {}) => {
  console.log(';payload', payload);
  return useQuery({
    queryKey:['rq_get_whatsapp_consent_report_api', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, locationId} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_WHATSAPP_CONSENT_API,
        null,
        certificate,
        {locationId: locationId},
        signal,
      );
    },
    ...options,
  });
};
